import React from "react";
import MultiSelect, { MultiSelectProps } from "@/components/atoms/MultiSelect";
import { useTranslation } from "react-i18next";
import { enumToStringArray } from "@/utils/enumToArray";
import OrderStatusEnum from "@/constants/enums/OrderStatusEnum";

/**
 * MultiSelectOrderTypes component renders a MultiSelect dropdown for Order Types.
 * It automatically populates options from OrderTypeEnum and handles translations.
 */
export const MultiSelectOrderStatus: React.FC<MultiSelectProps> = ({ ...restProps }: MultiSelectProps) => {
  const { t } = useTranslation();

  const orderStatusList = enumToStringArray(OrderStatusEnum);

  const options = orderStatusList.map((entry) => ({
    value: entry.toString(),
    label: t(`enumerables:orderStatus.${entry}`),
  }));

  return (
    <MultiSelect label={t("orders:orderType")} data-testid="multi-select-order-types" data={options} {...restProps} />
  );
};

export default MultiSelectOrderStatus;
